export { PlaidLogo } from './PlaidLogo';
export { QuickbooksLogo } from './QuickbooksLogo';
export { LightspeedLogo } from './LightspeedLogo';
export { MicrosoftDynamics365 } from './MicrosoftDynamics365';
export { AmazonLogo } from './AmazonLogo';
export { ShopifyLogo } from './ShopifyLogo';
export { CloverLogo } from './CloverLogo';
export { SquareLogo } from './SquareLogo';
export { SageLogo } from './SageLogo';
export { SalesforceLogo } from './SalesforceLogo';
export { StripeLogo } from './StripeLogo';
